<template>

  <div>

    <t-input-stock-list v-if="mount" :show="modalSearch"
                        :product-code-full="productCodeLabel"
                        :only-out="onlyOut"
                        :not-grouped="notGrouped"
                        :show-origin-label="showOriginLabel"
                        :stockItemType="stockItemType"
                        @onClose="onModalSearchClose()" @onSelected="onSelected"/>

      <t-input @focusout="getStockItemId" upper :required="required" class-input="w-fixed-200" label="Produto"
               v-model="productCodeLabel">

        <template #input-group-append>
          <t-button icon-search outline-secondary
                    v-if="command === 'insert' || command === 'update'"
                    @click="openModalSearch()"/>
        </template>

      </t-input>

<!--      <b-col class="text-left" style="margin-top: 22px;padding-right: 0px;">

        <div class="vs&#45;&#45;disabled_label form-control" style="margin-bottom: 8px">
          <span>{{ label }}</span>
        </div>

      </b-col>-->


  </div>

</template>
<script>
import tInputStockList from "@/components/template/form/finder/t-input-stock-list";
import productService from "@/services/modules/product/Product.service";
import ui from "@/assets/scripts/ui";

export default {
  name: 't-input-stock',
  components: {tInputStockList},
  data() {
    return {
      busy: false,
      stockProductId: 0,
      productCodeLabel: "",
      originCodeLabel: "",
      productName: "",
      model: "",
      groupProduct: "",
      unit: "",
      onSending: false,
      mount: false,
      modalSearch: false,
    }
  },
  props: {
    value: {
      type: null,
      default: ""
    },
    required: {
      type: Boolean,
      default: false
    },
    command: {
      type: String,
      default: "insert",
    },
    onlyOut: Boolean, //Filtrar somente saída de produtos
    notGrouped: Boolean, //Não agrupar por produto, deixar item a item para escolha
    showOriginLabel: Boolean, //Exibe o label pela Origem
    onlyNewProduced: Boolean,//Filtra stock somente de novas produções
    stockItemType:{
      type:[Number,String],
      default: ""
    }
  },
  mounted() {
    this.getStockItemResume(this.value)
  },
  methods: {

    onModalSearchClose() {
      this.modalSearch = false
    },

    onSelected(stockProductId) {
      this.onModalSearchClose()
      this.$emit("input", stockProductId)
    },

    openModalSearch() {

      document.activeElement.blur()

      this.modalSearch = true

      if (this.mount) {
        this.$bvModal.show('modal-product-search')
      } else {

        this.mount = true

        setTimeout(() => {
          this.$bvModal.show('modal-product-search')
        }, 200)

      }

    },

    async getStockItemResume(stockProductId) {

      if (stockProductId === 0) {
        this.productCodeLabel = ""
        this.productName = ""
        this.model = ""
        this.groupProduct = ""
        this.unit = ""

      } else {

        this.busy = true
        await this.getResumeStock('id', stockProductId)

      }

    },

    async getResumeStock(type, param) {

      await productService.getResume(type, param).then(resume => {

        this.stockProductId = resume.stockProductId
        this.originCodeLabel = resume.originCodeLabel
        this.productCodeLabel = resume.productCodeLabel
        this.productName = resume.name
        this.busy = false

      }).catch(error => {

        if (error.response) {

          if (error.response.status === 500) {
            ui.msg(this, 'Informação', error.response.data.message)
          }
        }
      })

    },

    async getStockItemId() {

      if (this.productCodeLabel === '') {
        this.stockProductId = 0
      } else {
        await this.getResumeProduct('code', this.productCodeLabel)
      }

      this.$emit("input", this.stockProductId)

    },

  },
  watch: {
    async value(v) {
      await this.getStockItemResume(v)
    },
    modalSearch() {

    }

  },

}
</script>